function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { SvgIcon, useTheme } from '@mui/material';
const ArrowIndicator = ({
  width = 18,
  height = 16,
  ...rest
}) => {
  const theme = useTheme();
  const iconColor = theme.palette.grey[700];
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, rest, {
    viewBox: "0 0 18 16",
    width: width,
    height: height,
    sx: {
      width,
      height
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7321 15C9.96225 16.3333 8.03775 16.3333 7.26795 15L0.339746 3C-0.430054 1.66667 0.532198 0 2.0718 0L15.9282 0C17.4678 0 18.4301 1.66667 17.6603 3L10.7321 15Z",
    fill: iconColor
  }));
};
export default ArrowIndicator;